import { ChangeEvent, memo } from 'react';

import { FormControlLabel } from '@material-ui/core';

import { Checkbox } from '@components/SharedComponents/Checkbox';

import './index.scss';

const labelControlClasses = {
  root: 'label-container',
};

const checkboxClasses = {
  root: 'checkbox',
};

interface CheckboxFormFieldProps {
  label: string;
  value?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  dataTestId?: string;
}

// If you find this component and want to reuse it - feel free to do it
export const CheckboxFormField = memo(
  ({ label, value, onChange, dataTestId }: CheckboxFormFieldProps) => {
    return (
      <FormControlLabel
        classes={labelControlClasses}
        label={label}
        control={
          <Checkbox
            classes={checkboxClasses}
            checked={value ?? false}
            onChange={onChange}
            dataTestId={dataTestId}
          />
        }
      />
    );
  }
);

CheckboxFormField.displayName = 'CheckboxFormField';
